module.exports = __webpack_public_path__ + "static/media/instbk.7a7ac98d.JPG";